// export enum UserRoles { user, blogger, admin}
export enum UserRoles {
	user = 'USER',
	blogger = 'blogger',
	admin = 'ADMIN'
}
